// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3GZaT","search":"Settings_search__2Tgle","filter":"Settings_filter__2r_S0"};